/**
 * @generated SignedSource<<c75419fc3e3624402772aef4227b7291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QuestionType = "CHILDREN" | "DATE" | "INPUT" | "MULTI_PUNCH" | "SELECTION";
export type DailyPonderBannerQuery$variables = {
  id: string;
};
export type DailyPonderBannerQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly possibleAnswers?: {
      readonly answers?: ReadonlyArray<{
        readonly answerKey: string;
        readonly label: string;
      }> | null;
      readonly type: QuestionType;
    } | null;
    readonly responseStatistics?: ReadonlyArray<{
      readonly correct: boolean;
      readonly key: string;
      readonly ratio: number;
      readonly selected: boolean;
    }> | null;
  } | null;
};
export type DailyPonderBannerQuery = {
  response: DailyPonderBannerQuery$data;
  variables: DailyPonderBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SelectionQuestionAnswer",
    "kind": "LinkedField",
    "name": "answers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "answerKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "SelectionQuestionAnswers",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "MultiPunchQuestionAnswers",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PollResponseStatistic",
  "kind": "LinkedField",
  "name": "responseStatistics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selected",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DailyPonderBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "possibleAnswers",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "PollQuestion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DailyPonderBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "possibleAnswers",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "PollQuestion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b6eabd6b328729f70777617c558e04f",
    "id": null,
    "metadata": {},
    "name": "DailyPonderBannerQuery",
    "operationKind": "query",
    "text": "query DailyPonderBannerQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PollQuestion {\n      id\n      possibleAnswers {\n        __typename\n        type\n        ... on SelectionQuestionAnswers {\n          answers {\n            answerKey\n            label\n          }\n        }\n        ... on MultiPunchQuestionAnswers {\n          answers {\n            answerKey\n            label\n          }\n        }\n      }\n      responseStatistics {\n        key\n        ratio\n        correct\n        selected\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2befe2141fe1570e698323ac3c8cf83a";

export default node;
